"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const blueprint_1 = require("@groma-dev/blueprint");
const Avatar_module_scss_1 = __importDefault(require("./Avatar.module.scss"));
/**
 * Avatar component to render in the header when the user is authenticated. The root element is a button.
 * @param props
 * @constructor
 */
const Avatar = (props) => {
    const { testId, children, className } = props, remainingProps = __rest(props, ["testId", "children", "className"]);
    const dti = (0, blueprint_1.getTestIdAttribute)(testId);
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({}, remainingProps, { className: (0, blueprint_1.classNames)('Header-avatar-local', className, Avatar_module_scss_1.default.avatar) }, dti, { children: children })));
};
exports.Avatar = Avatar;
